module.exports = __webpack_public_path__ + "static/img/page3-bc.44abc51d.png";